import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import i18n from './i18n';

// Import styles
import 'primevue/resources/themes/lara-light-teal/theme.css';
import 'primeicons/primeicons.css';
import './tailwind.css'; // Tailwind CSS
import './style.css';

import App from './App.vue';
import router from './router';

// Create the app instance
const app = createApp(App);

// Use plugins
app.use(createPinia());
app.use(router);
app.use(PrimeVue);
app.use(i18n); // Add i18n support

// Mount the app
app.mount('#app');
